import Turbolinks from "turbolinks"
import { initMobileNavBehavior } from '@utils/interaction'

Turbolinks.start()

document.addEventListener('turbolinks:load', async () => {
	if (window.innerWidth <= 600) initMobileNavBehavior()

	const controller = document.body.getAttribute('data-controller')
	try {
		const module = await import(`./${controller}`)
		module.default()
	} catch (e) {
		console.error(e)
	}
})
